export default class EngineerViewModel {
    public nomEngineer?: string = '';
    public deptEngineer?: string = '';
}